import { useEffect } from 'react';
import { useNavbarClickHandlers } from './useNavbarClickHandlers';
import { CUSTOM_EVENT_IDS } from '../../constants/customEvents';

export const useNavbarListeners = (isEnabled = true) => {
  const handlers = useNavbarClickHandlers();

  useEffect(() => {
    const listener = (event) => {
      const handler = handlers[event?.detail?.item];
      handler?.();
    };

    if (isEnabled) {
      window.addEventListener(CUSTOM_EVENT_IDS.CasinoNavbarCLick, listener);
    }

    return () => {
      if (isEnabled) {
        window.removeEventListener(
          CUSTOM_EVENT_IDS.CasinoNavbarCLick,
          listener
        );
      }
    };
  }, [handlers, isEnabled]);
};
